export class PershingCommonLabels {
    public static REQUIRED_ERROR_CASE_MESSAGE = 'NXP-PERSHING-COMMON.PERSHING-INPUT.REQUIRED_ERROR_MESSAGE';
    public static DEFAULT_ERROR_CASE_MESSAGE = 'NXP-PERSHING-COMMON.PERSHING-INPUT.DEFAULT_ERROR_MESSAGE';
}
